__turbopack_context__.v({
  "articleContent": "ArticleContent-module-scss-module__7ibXFa__articleContent",
  "content": "ArticleContent-module-scss-module__7ibXFa__content",
  "contentWrapper": "ArticleContent-module-scss-module__7ibXFa__contentWrapper",
  "paragraph": "ArticleContent-module-scss-module__7ibXFa__paragraph",
  "paragraphText": "ArticleContent-module-scss-module__7ibXFa__paragraphText",
  "subtitle": "ArticleContent-module-scss-module__7ibXFa__subtitle",
});
